(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vp-cod-cart"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = () => {
    const components = Array.from(document.querySelectorAll('.vp-cod-cart'));
    if (!components.length) return;

    const component = components[0];
    if (component.dataset.ready === 'true') return;
    component.dataset.ready = 'true';
    document.documentElement.classList.add('vp-custom-cart-active');

    const confirmDialog = component.querySelector('.vp-cart-confirm');
    const drawerDialog = component.querySelector('.vp-cart-drawer');
    const itemsElement = component.querySelector('[data-vp-items]');
    const emptyElement = component.querySelector('[data-vp-empty]');
    const footerElement = component.querySelector('[data-vp-footer]');
    const statusElement = component.querySelector('[data-vp-status]');
    const root = (component.dataset.root || '/').replace(/\/$/, '');
    const cartUrl = `${root}/cart.js`;
    const changeUrl = `${root}/cart/change.js`;
    const tiers = [
      { amount: Number(component.dataset.tierOne), percent: Number(component.dataset.tierOnePercent) },
      { amount: Number(component.dataset.tierTwo), percent: Number(component.dataset.tierTwoPercent) },
      { amount: Number(component.dataset.tierThree), percent: Number(component.dataset.tierThreePercent) }
    ];
    let cartState = null;
    let refreshRequest = null;
    let lastAddNotice = 0;
    let addIntentUntil = 0;

    const escapeSelectorValue = (value) => {
      if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
      return String(value).replace(/["\\]/g, '\\$&');
    };

    const formatMoney = (cents) => {
      const currency = component.dataset.currency || window.Shopify?.currency?.active || 'EUR';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency
        }).format((Number(cents) || 0) / 100);
      } catch (error) {
        return `€${((Number(cents) || 0) / 100).toFixed(2)}`;
      }
    };

    const setStatus = (message) => {
      statusElement.textContent = message || '';
    };

    const closeNativeCart = () => {
      document.querySelectorAll('cart-drawer, cart-notification, #CartDrawer').forEach((element) => {
        if (typeof element.close === 'function') {
          try { element.close(); } catch (error) {}
        }
        element.classList.remove('active', 'animate', 'is-open', 'open');
        element.removeAttribute('open');
      });
      document.body.classList.remove('overflow-hidden');
    };

    const setDialogOpen = (dialog, open) => {
      if (!dialog) return;
      if (open) closeNativeCart();
      if (open && !dialog.open) dialog.showModal();
      if (!open && dialog.open) dialog.close();
      document.documentElement.classList.toggle('vp-cart-is-open', confirmDialog.open || drawerDialog.open);
    };

    const updateCartCount = (count) => {
      const selectors = [
        '[data-cart-count]',
        '.cart-count-bubble span[aria-hidden="true"]',
        '.header__icon--cart .cart-count-bubble span:first-child'
      ];
      document.querySelectorAll(selectors.join(',')).forEach((element) => {
        element.textContent = String(count);
      });
    };

    const cartItemMarkup = (item) => {
      const article = document.createElement('article');
      article.className = 'vp-cart-item';
      article.dataset.key = item.key;

      const image = document.createElement('img');
      image.className = 'vp-cart-item__image';
      image.width = 76;
      image.height = 76;
      image.loading = 'lazy';
      image.alt = '';
      image.src = item.featured_image?.url || item.image || '';

      const body = document.createElement('div');
      const title = document.createElement('a');
      title.className = 'vp-cart-item__title';
      title.href = item.url || '#';
      title.textContent = item.product_title || item.title || '';

      const variant = document.createElement('span');
      variant.className = 'vp-cart-item__variant';
      variant.textContent = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';

      const price = document.createElement('span');
      price.className = 'vp-cart-item__price';
      price.textContent = `${formatMoney(item.final_price || item.price)} ${component.dataset.eachLabel || 'each'}`;

      const controls = document.createElement('div');
      controls.className = 'vp-cart-item__controls';
      controls.setAttribute('aria-label', 'Quantity');

      const minus = document.createElement('button');
      minus.type = 'button';
      minus.textContent = '−';
      minus.dataset.vpQuantity = String(Math.max(0, item.quantity - 1));
      minus.setAttribute('aria-label', 'Decrease quantity');

      const quantity = document.createElement('span');
      quantity.textContent = String(item.quantity);

      const plus = document.createElement('button');
      plus.type = 'button';
      plus.textContent = '+';
      plus.dataset.vpQuantity = String(item.quantity + 1);
      plus.setAttribute('aria-label', 'Increase quantity');

      controls.append(minus, quantity, plus);
      body.append(title, variant, price, controls);

      const remove = document.createElement('button');
      remove.className = 'vp-cart-item__remove';
      remove.type = 'button';
      remove.textContent = '×';
      remove.dataset.vpQuantity = '0';
      remove.setAttribute('aria-label', 'Remove item');

      article.append(image, body, remove);
      return article;
    };

    const renderReward = (cart) => {
      const subtotal = Number(cart.original_total_price || cart.items_subtotal_price || 0);
      const highest = tiers[tiers.length - 1];
      const nextTier = tiers.find((tier) => subtotal < tier.amount);
      const unlockedTier = [...tiers].reverse().find((tier) => subtotal >= tier.amount);
      const rewardCopy = component.querySelector('[data-vp-reward-copy]');
      const progress = component.querySelector('[data-vp-progress]');

      if (nextTier && unlockedTier) {
        const remaining = formatMoney(nextTier.amount - subtotal);
        rewardCopy.textContent = (component.dataset.unlockedTierTemplate || '{current}% OFF unlocked · Add {amount} for {next}% OFF')
          .replace('{current}', String(unlockedTier.percent))
          .replace('{amount}', remaining)
          .replace('{next}', String(nextTier.percent));
      } else if (nextTier) {
        const remaining = formatMoney(nextTier.amount - subtotal);
        rewardCopy.innerHTML = '';
        const template = component.dataset.nextTierTemplate || 'Add {amount} more · unlock {percent}% off';
        const parts = template
          .replace('{amount}', remaining)
          .replace('{percent}', String(nextTier.percent))
          .split(/(\d+(?:[.,]\d+)?\s?%|[^\s]+\s?\d+[.,]\d+)/);
        parts.forEach((part) => {
          const node = document.createElement(/\d/.test(part) ? 'strong' : 'span');
          node.textContent = part;
          rewardCopy.append(node);
        });
      } else {
        rewardCopy.textContent = component.dataset.maxTierText || 'Best discount unlocked';
      }

      progress.style.width = `${Math.min(100, highest.amount ? subtotal / highest.amount * 100 : 0)}%`;
      component.querySelectorAll('[data-vp-tier]').forEach((element, index) => {
        element.classList.toggle('is-unlocked', subtotal >= tiers[index].amount);
      });
    };

    const renderCart = (cart) => {
      cartState = cart;
      itemsElement.replaceChildren(...cart.items.map(cartItemMarkup));
      const isEmpty = cart.item_count === 0;
      itemsElement.hidden = isEmpty;
      emptyElement.hidden = !isEmpty;
      footerElement.hidden = isEmpty;
      updateCartCount(cart.item_count);

      if (isEmpty) return;

      renderReward(cart);
      const originalTotal = Number(cart.original_total_price || cart.items_subtotal_price || cart.total_price || 0);
      const actualTotal = Number(cart.total_price || 0);
      const eligibleTier = [...tiers].reverse().find((tier) => originalTotal >= tier.amount);
      const actualSaving = Math.max(Number(cart.total_discount || 0), originalTotal - actualTotal, 0);
      const previewSaving = eligibleTier
        ? cart.items.reduce((sum, item) => {
            const unitPrice = Number(item.original_price || item.price || 0);
            const unitSaving = Math.floor(unitPrice * eligibleTier.percent / 100);
            return sum + unitSaving * Number(item.quantity || 0);
          }, 0)
        : 0;
      const saving = actualSaving || previewSaving;
      const displayedTotal = actualSaving ? actualTotal : Math.max(0, originalTotal - previewSaving);
      component.querySelector('[data-vp-subtotal]').textContent = formatMoney(originalTotal);
      component.querySelector('[data-vp-total]').textContent = formatMoney(displayedTotal);
      const savingRow = component.querySelector('[data-vp-saving-row]');
      savingRow.hidden = saving <= 0;
      component.querySelector('[data-vp-discount]').textContent = saving > 0 ? `−${formatMoney(saving)}` : '';
    };

    const fetchCart = async () => {
      if (refreshRequest) return refreshRequest;
      refreshRequest = fetch(cartUrl, { headers: { Accept: 'application/json' } })
        .then((response) => {
          if (!response.ok) throw new Error('Cart request failed');
          return response.json();
        })
        .then((cart) => {
          renderCart(cart);
          setStatus('');
          document.dispatchEvent(new CustomEvent('vp:cart:updated', { detail: { cart } }));
          return cart;
        })
        .catch(() => {
          if (!cartState || cartState.item_count === 0) setStatus('Unable to load cart. Please try again.');
          else setStatus('');
          return null;
        })
        .finally(() => {
          refreshRequest = null;
        });
      return refreshRequest;
    };

    const openDrawer = async () => {
      closeNativeCart();
      setDialogOpen(confirmDialog, false);
      setDialogOpen(drawerDialog, true);
      setStatus(component.dataset.loadingText || 'Loading…');
      await fetchCart();
    };

    const showAddedConfirmation = async (addedItem) => {
      if (Date.now() > addIntentUntil) {
        await fetchCart();
        return;
      }
      addIntentUntil = 0;
      const now = Date.now();
      if (now - lastAddNotice < 350) return;
      lastAddNotice = now;

      const item = Array.isArray(addedItem?.items) ? addedItem.items[0] : addedItem;
      if (!item) return;

      closeNativeCart();
      window.setTimeout(closeNativeCart, 80);
      window.setTimeout(closeNativeCart, 260);

      const image = component.querySelector('[data-vp-confirm-image]');
      image.src = item.featured_image?.url || item.image || '';
      component.querySelector('[data-vp-confirm-product]').textContent = item.product_title || item.title || '';
      component.querySelector('[data-vp-confirm-variant]').textContent = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      component.querySelector('[data-vp-confirm-price]').textContent = formatMoney(item.final_price || item.price);
      setDialogOpen(drawerDialog, false);
      setDialogOpen(confirmDialog, true);
      await fetchCart();
    };

    const changeLine = async (key, quantity) => {
      setStatus(component.dataset.loadingText || 'Updating…');
      const response = await fetch(changeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      if (!response.ok) {
        setStatus(component.dataset.emptyText || 'Unable to update cart.');
        return;
      }
      const cart = await response.json();
      renderCart(cart);
      setStatus('');
      document.dispatchEvent(new CustomEvent('vp:cart:updated', { detail: { cart } }));
    };

    const easySellButtonSelectors = [
      '.es-popup-button-drawer',
      '#cart-notification-form #es-popup-button',
      'cart-drawer #es-popup-button',
      '#CartDrawer #es-popup-button',
      '#es-popup-button',
      '.es-popup-button',
      '[id^="es-popup-button-"]',
      '[data-easysell-trigger]',
      '[data-easy-sell-trigger]'
    ];

    const findEasySellButton = () => {
      for (const selector of easySellButtonSelectors) {
        const source = Array.from(document.querySelectorAll(selector))
          .find((element) => !component.contains(element));
        if (source) return source;
      }
      return null;
    };

    const prepareEasySellButton = () => {
      const source = findEasySellButton();
      if (!source) return false;
      source.dataset.vpEasysellSource = 'true';
      source.setAttribute('aria-hidden', 'true');
      const clickable = source.matches('button, a, input, [role="button"]')
        ? source
        : source.querySelector('button, a, input[type="button"], input[type="submit"], [role="button"]');
      if (clickable) clickable.setAttribute('tabindex', '-1');
      return true;
    };

    const setOrderButtonsBusy = (busy) => {
      component.querySelectorAll('[data-vp-checkout]').forEach((button) => {
        button.disabled = busy;
        button.setAttribute('aria-busy', String(busy));
      });
    };

    const triggerEasySell = async () => {
      await fetchCart();
      const originDialog = confirmDialog.open ? confirmDialog : drawerDialog;
      setOrderButtonsBusy(true);
      setDialogOpen(confirmDialog, false);
      setDialogOpen(drawerDialog, false);
      closeNativeCart();

      const clickWhenReady = (remaining) => {
        const button = findEasySellButton();
        if (button) {
          prepareEasySellButton();
          closeNativeCart();
          const clickable = button.matches('button, a, input, [role="button"]')
            ? button
            : button.querySelector('button, a, input[type="button"], input[type="submit"], [role="button"]');
          (clickable || button).click();
          window.setTimeout(() => setOrderButtonsBusy(false), 800);
          return;
        }
        if (remaining <= 0) {
          setOrderButtonsBusy(false);
          setDialogOpen(originDialog, true);
          setStatus(component.dataset.easysellLoading || 'Order form is loading. Please tap the order button below.');
          return;
        }
        window.setTimeout(() => clickWhenReady(remaining - 1), 200);
      };
      clickWhenReady(20);
    };

    const markCartLinks = () => {
      document.querySelectorAll('a[href]').forEach((link) => {
        if (component.contains(link)) return;
        let url;
        try { url = new URL(link.href, window.location.origin); } catch (error) { return; }
        if (url.origin !== window.location.origin || !url.pathname.replace(/\/$/, '').endsWith('/cart')) return;
        link.dataset.vpCartTrigger = 'true';
        link.href = '#vp-cart';
      });
    };

    markCartLinks();
    let easySellSetupAttempts = 0;
    const easySellSetupTimer = window.setInterval(() => {
      easySellSetupAttempts += 1;
      const easySellButtonReady = prepareEasySellButton();
      if (easySellButtonReady || easySellSetupAttempts >= 40) window.clearInterval(easySellSetupTimer);
    }, 250);

    component.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      if (target.closest('[data-vp-close-confirm], [data-vp-continue]')) setDialogOpen(confirmDialog, false);
      if (target.closest('[data-vp-close-drawer]')) setDialogOpen(drawerDialog, false);
      if (target.closest('[data-vp-view-cart]')) openDrawer();
      if (target.closest('[data-vp-checkout]')) triggerEasySell();

      const quantityButton = target.closest('[data-vp-quantity]');
      if (quantityButton) {
        const item = quantityButton.closest('.vp-cart-item');
        if (item?.dataset.key) changeLine(item.dataset.key, Number(quantityButton.dataset.vpQuantity));
      }
    });

    [confirmDialog, drawerDialog].forEach((dialog) => {
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) setDialogOpen(dialog, false);
      });
      dialog.addEventListener('close', () => {
        document.documentElement.classList.toggle('vp-cart-is-open', confirmDialog.open || drawerDialog.open);
      });
    });

    window.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const action = target?.closest('button, a, [role="button"], input[type="button"], input[type="submit"], #es-popup-button, .es-popup-button');
      const actionText = String(action?.textContent || action?.value || '').replace(/\s+/g, ' ').trim();
      const isEasySellAction = Boolean(
        action &&
        (action.closest('[data-vp-easysell-source], #es-form-hook, [class*="easysell" i], [id*="easysell" i], [class*="easy-sell" i], [id*="easy-sell" i]') ||
          /€0\s*to\s*order|pay\s*on\s*(receipt|delivery)/i.test(actionText))
      );
      if (isEasySellAction) {
        setDialogOpen(confirmDialog, false);
        setDialogOpen(drawerDialog, false);
        closeNativeCart();
      }
      const isAddToCartAction = Boolean(
        action &&
        !component.contains(action) &&
        !isEasySellAction &&
        (action.matches('[name="add"], [data-add-to-cart], [class*="add-to-cart" i], [id*="add-to-cart" i]') ||
          /add\s*to\s*cart|加入购物车/i.test(actionText))
      );
      if (isAddToCartAction) addIntentUntil = Date.now() + 5000;
      const link = target?.closest('a[href], [data-vp-cart-trigger], #cart-icon-bubble, .header__icon--cart, [aria-controls*="CartDrawer"]');
      if (!link || component.contains(link)) return;
      if (link.matches('[data-vp-cart-trigger], #cart-icon-bubble, .header__icon--cart, [aria-controls*="CartDrawer"]')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openDrawer();
        return;
      }
      let url;
      try {
        url = new URL(link.href, window.location.origin);
      } catch (error) {
        return;
      }
      if (url.origin !== window.location.origin) return;
      if (!url.pathname.replace(/\/$/, '').endsWith('/cart')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      openDrawer();
    }, true);

    const isCartAddRequest = (input, options) => {
      const url = typeof input === 'string' ? input : input?.url || '';
      const method = String(options?.method || input?.method || 'GET').toUpperCase();
      return method === 'POST' && /\/cart\/add(?:\.js)?(?:\?|$)/.test(url);
    };

    const handleAddedResponse = async (addedItem) => {
      showAddedConfirmation(addedItem);
    };

    const originalFetch = window.fetch.bind(window);
    window.fetch = (...argumentsList) => {
      const requestIsAdd = isCartAddRequest(argumentsList[0], argumentsList[1]);
      return originalFetch(...argumentsList).then((response) => {
        if (requestIsAdd && response.ok) {
          response.clone().json().then(handleAddedResponse).catch(() => fetchCart());
        }
        return response;
      });
    };

    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url, ...rest) {
      this._vpIsCartAdd = String(method).toUpperCase() === 'POST' && /\/cart\/add(?:\.js)?(?:\?|$)/.test(String(url));
      return originalOpen.call(this, method, url, ...rest);
    };
    XMLHttpRequest.prototype.send = function (...argumentsList) {
      if (this._vpIsCartAdd) {
        this.addEventListener('load', () => {
          if (this.status < 200 || this.status >= 300) return;
          try {
            handleAddedResponse(JSON.parse(this.responseText));
          } catch (error) {
            fetchCart();
          }
        }, { once: true });
      }
      return originalSend.apply(this, argumentsList);
    };

    fetchCart();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
